import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { initializeAnalytics } from './utils/analytics';

initializeAnalytics(process.env.REACT_APP_GA_MEASUREMENT_ID, process.env.NODE_ENV);

ReactDOM.render(
  <>
    <App />
  </>,
  document.getElementById('root'),
);
